import {BaseStage} from "./BaseStage";
import {loading, stopLoading} from "../../../helpers/loading";
import Axios from "axios";
import createElement from "../../../helpers/createElement";
import handleAjaxErrorV2 from "../../../helpers/handleAjaxErrorV2";
import {TotalPreviewComponent} from "../TotalPreviewComponent/TotalPreviewComponent";
import {handleAjaxSuccess} from "../../../helpers/swalHelper";
import {getSingleInputElementByNameV3} from "../../../helpers/forms/formInputsHelpers";

class OrderSummaryStage extends BaseStage {
    /** @var {TotalPreviewComponent} */
    totalPreviewComponent;

    constructor(globalState) {
        super(globalState);

        this.domContainer = document.querySelector(`.stage.${this.getStageKey()}`)

        // Get route contents
        const getViewHtmlRoute = this.domContainer.dataset.getViewRoute;

        loading();

        Axios.post(
            getViewHtmlRoute,
            this.globalState.getOrderDataForServer(),
        )
            .then(response => {
                // Retrieve HTML from server
                const viewHtml = createElement(response.data.view);

                // Replace contents from server
                this.domContainer.innerHTML = viewHtml.innerHTML;

                // Run default components initializations
                this.initSharedComponents();

                this.initView();
            })
            .catch(error => {
                handleAjaxErrorV2(error)

                this.globalState.stageManager.previousStage();
                this.globalState.stageManager.clearStageInstance('summary');
            })
            .finally(stopLoading)
    }

    /**
     * @return {PublicTicketsFormDefs.Stage}
     */
    getStageKey() {
        // noinspection JSValidateTypes
        return 'summary';
    }

    initView() {
        this.placeOrderRoute = this.domContainer.dataset.placeOrderRoute;

        this.totalPreviewComponent = new TotalPreviewComponent(
            this.domContainer.querySelector('.totals-preview-wrapper'),
            this.globalState,
        )

        // Fill in CC last four
        const lastFourContainer = this.domContainer.querySelector('.cc_last_four');
        if (lastFourContainer) {
            lastFourContainer.innerHTML = this.globalState.paymentInfo.cc_number.slice(-4);
        }

        // Setup edit buttons
        this.domContainer.querySelectorAll('.change-payment-settings-button').forEach(button => {
            button.addEventListener('click', () => {
                this.globalState.stageManager.goToStage('payment-info');
            })
        })

        // Setup edit buttons
        this.domContainer.querySelectorAll('.change-order-details-button').forEach(button => {
            button.addEventListener('click', () => {
                this.globalState.stageManager.goToStage('seat-type-select');
            })
        })

        // Setup how did you find about us text
        const howDidYouFindUsSelect = getSingleInputElementByNameV3(this.domContainer, 'how_did_you_find_us_select');
        const howDidYouFindUsInput = getSingleInputElementByNameV3(this.domContainer, 'how_did_you_find_us_input');

        // Setup select change event
        howDidYouFindUsSelect.addEventListener('change', () => {
            if (howDidYouFindUsSelect.value === 'other') {
                // Show custom box
                howDidYouFindUsInput.classList.remove('d-none')
                // And clear its value
                howDidYouFindUsInput.value = '';
            } else {
                // Set predefined value
                howDidYouFindUsInput.value = howDidYouFindUsSelect.value;
                // And hide custom box
                howDidYouFindUsInput.classList.add('d-none')
            }

            // Trigger change event in input to update in memory
            howDidYouFindUsInput.dispatchEvent(new InputEvent('change'));
        })

        // Setup change even on input to sync value in memory
        howDidYouFindUsInput.addEventListener('change', () => {
            this.globalState.setHowDidYouFindUs(howDidYouFindUsInput.value);
        })

        // Override default next stage button
        this.domContainer.querySelector('.next-stage-button')
            .addEventListener(
                'click', e => {
                    e.stopPropagation();
                    e.preventDefault();

                    this.placeOrder();
                },
                {
                    capture: true,
                }
            )

        this.updateTotals();

        // Wait a bit and enable next stage button
        setTimeout(() => {
            this.enableNextStageButton()
        }, 1000)
    }

    updateTotals() {
        this.totalPreviewComponent.updateTotalsFromServer().then();
    }

    placeOrder() {
        const orderData = this.globalState.getOrderDataForServer(true);

        loading();
        Axios.post(
            this.placeOrderRoute,
            orderData,
        )
            .then(response => {
                // Let the user leave without warning
                window.onbeforeunload = undefined;

                handleAjaxSuccess(response);
            })
            .catch(error => {
                // Make sure the error appears as a swal popup
                handleAjaxErrorV2(error, createElement('<div></div>'))
            })
            .finally(stopLoading)
    }
}

export {OrderSummaryStage};
